import { useState, useEffect } from 'react';
import api from '../api';

const EMPTY_OPTIONS = {
  customers: [],
  hosts: [],
  countries: [],
  crops: [],
  study_types: [],
  trial_types: [],
  users: [],
  years: [],
};

// Dropdown values for the trial search filters (POST /trials/filter-options)
export default function useTrialFilterOptions() {
  const [options, setOptions] = useState(EMPTY_OPTIONS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    api.post('/trials/filter-options')
      .then(res => { if (!cancelled) setOptions({ ...EMPTY_OPTIONS, ...res.data }); })
      .catch(() => { if (!cancelled) setError('Failed to load filter options'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { options, loading, error };
}
